import React, { FC, useState } from 'react';
import styled from '@emotion/styled';
import { Button } from '$components/elements/button';
import { useBasket } from '~/store/basket';
import { SvgIcon } from '$components/elements/svg-icon';

type Props = {
    itemNumber: string;
    buttonText?: string;
    onAddToBasketSuccess?: () => void;
};

export const PickupStoreItemPurchase: FC<Props> = ({ itemNumber, buttonText, onAddToBasketSuccess }): JSX.Element => {
    const { addToBasket } = useBasket();
    const [isLoading, setIsLoading] = useState(false);

    const onAddToBasket = async () => {
        setIsLoading(true);
        await addToBasket(itemNumber, 1);
        setIsLoading(false);
        onAddToBasketSuccess?.();
    };

    return (
        <PurchaseButton onClick={onAddToBasket} loading={isLoading}>
            <PurchaseIcon color="white" size={20} svg="basket" />
            {buttonText}
        </PurchaseButton>
    );
};

const PurchaseIcon = styled(SvgIcon)(({ theme }) => ({
    marginRight: theme.space[2],
}));

const PurchaseButton = styled(Button)({
    padding: '6px 16px',
    height: 'initial',
});
